import React, { useState } from "react";
import { useEffect, useRef } from "react";

// import "./FullPage2.css";
import logo from './img/bot.png'
// import refresh from './img/refresh-3.png'
// Removed unused imports
import user from './img/user.png'
import admin from './img/admin.png'
// import sendInactive from "./img/send-inactive.png"
// import sendActive from "./img/send-active.png"
// import waitingText from "./img/KmNL43wi3g.gif"
// import waitingText from "./img/load.webp"
// import loadHistory from "./img/loader-message.gif"
import axios from "axios";
// import PhoneInput from 'react-international-phone'
// import 'react-international-phone/style.css';
// import 'react-phone-number-input/style.css'

import {
    isValidPhoneNumber
} from 'react-phone-number-input'
// import MyPhoneInput from './MyPhoneInput'
// import MyPhoneInput from './components/MyPhoneInput'

// import Autocomplete from "react-google-autocomplete";
// import Autocomplete from "./Autocomplete2";
import Autocomplete from "./mui-components/Autocomplete";
import { useSearchParams } from 'react-router-dom';
// import SendIcon from './components/SendIcon';
import { getContrastColor, 
  // getContrastColorBackground 
} from './components/color';
import { GOOGLE_API_KEY, getApiBaseUrl } from './components/constant'
// import TimeSelector from "./components/TimeController"
// import ErrorComponent from "./components/Error"
import LangGlobe from './mui-components/LangGlobe';

import { useNavigate } from "react-router-dom";
import { t } from './i18n';
import {
  Box,
  Button,
  IconButton,
  Typography,
  TextField,
  Stack,
  Container,
  CircularProgress
} from "@mui/material";

import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import ChatMessage from './mui-components/ChatMessage'
import ChatFooter from './mui-components/ChatFooter';
import PlainPhoneInput from './mui-components/PlainPhoneInput'

// import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorComponent from "./mui-components/Error"

// const TimeToRetry = 10 // seconds

const initMessage = { content: 'Salut je suis votre assistant virtuel, comment puis-je vous aider ?', role: "bot", status: 'in-progress', created_at: new Date(), lang: 'fr'}
// const RESET_TIME = 1 * 60 * 60 * 1000 // 1 heure
// const RESET_TIME = 1 * 60 * 1000
const RESET_TIME = 1 * 60 * 60 * 1000

const FullPageChat = (props) => {
    // Removed unused props
    const navigate = useNavigate();

    const {
      company_name, 
      logoColor = "#007bff", 
      // TCM_API_KEY, 
      //logoLink = '#', 
      // label="Ecrirez votre message...",
      apiBaseUrl
    } = props

    // Get the base URL with runtime override support
    // const baseUrl = getApiBaseUrl(apiBaseUrl);
    const [baseUrl, setBaseUrl] = useState(getApiBaseUrl(apiBaseUrl))
    const fileInputRef = useRef(null);
    const [imageData, setImageData] = useState(null);
    const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");
    const [endTime, setEndTime] = useState(new Date().getTime() + RESET_TIME);

    // const headers = useMemo(() => ({
    //   'TCM_API_KEY': TCM_API_KEY,
    // }), [TCM_API_KEY]);

    const [messages, setMessages] = useState([
        // { content: 'bonjour chatgpt', role: "user" },
        // { content: 'Que puis-je faire pour vous ?', role: "bot" },
        {...initMessage, content: t('initMessage', lang)},
    ]);
    
    const [showPage, setShowPage] = useState(false);
    // const [canReload, setCanReload] = useState(false);

    const [input, setInput] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    // const [lang, setLang] = useState("en");
    
    const [client, setClient] = useState({
      // chatbot_place_holder: '#fff',
      // chatbot_place_holder: '#f3a'
      // line_color: "#000fff",
    });
    const [company, setCompany] = useState(null)
    const [errors, setErrors] = useState({ email: '', phone: '' });
    const [errorBackend, setErrorBackend] = useState(false)

    const [conversationId, setConversationId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingHistory, setIsLoadingHistory] = useState(true);
    // const [historyLoaded, setHistoryLoaded] = useState(false);

    const [disabledInput, setDisabledInput] = useState(false);
    // const [searchParams, setSearchParams] = useSearchParams();
    const [searchParams] = useSearchParams();

    // const [api_key, setApiKey] = useState("");
    const [headers, setHeaders] = useState(null);

    const chatBodyRef = useRef(null);
    // const PROD_BACKEND_API = process.env.REACT_APP_PROD_API_BASE_URL 
    // const PREPROD_BACKEND_API = process.env.REACT_APP_PROD_API_BASE_URL 
    // console.log(PROD_BACKEND_API, PREPROD_BACKEND_API)
    const PROD_BACKEND_API = process.env.REACT_APP_PROD_BACKEND_API || 'https://dev-2.api.quebotia.com/api/v1'
    const PREPROD_BACKEND_API = process.env.REACT_APP_PREPROD_BACKEND_API || 'https://preprod.api.quebotia.com/api/v1'
    const APP_BACKEND_API = process.env.REACT_APP_APP_BACKEND_API || 'https://api.quebotia.com/api/v1'
    // const APP_BACKEND_API = process.env.REACT_APP_APP_BACKEND_API || 'https://api.quebotia.com/api/v1'
    // const PROD_BACKEND_API = 'https://tcm-chatbot-api.azurewebsites.net/api/v1'

    // useEffect(() => {
    //   if (conversationId) {
    //     const item = {
    //       value: conversationId,
    //       expiry: new Date().getTime() + RESET_TIME,
    //     };
    //     localStorage.setItem("conversation-id", JSON.stringify(item));
    //   }
    // }, [conversationId]); // Triggers on new messages or loading indicator
  
    useEffect(() => {
      const api_key_url = searchParams.get('API_KEY');
      const mode = searchParams.get('mode') || 'prod'

      if (api_key_url !== null) {
        // setApiKey(api_key_url);
        // setHeaders({ 'TCM_API_KEY': api_key_url, 'mode': mode, 'Content-Type': "multipart/form-data" });
        setHeaders({ 'TCM_API_KEY': api_key_url, 'mode': mode});
        // const baseUrl = environment === "prod" ? getApiBaseUrl(PROD_BACKEND_API) : getApiBaseUrl(PREPROD_BACKEND_API)
        if(mode === "prod"){
          setBaseUrl(getApiBaseUrl(PROD_BACKEND_API))
        }else if(mode === "preprod"){
          setBaseUrl(getApiBaseUrl(PREPROD_BACKEND_API))
        }else if(mode === "app"){
          setBaseUrl(getApiBaseUrl(APP_BACKEND_API))
        }
      }
    }, [searchParams, PROD_BACKEND_API, PREPROD_BACKEND_API, APP_BACKEND_API]); // Only runs when searchParams change
    
    // const messagesLengthRef = useRef(messages.length);

    const handleReset = React.useCallback(() => {
      localStorage.removeItem("last-buttons");
      localStorage.removeItem("slots-rdv");
      localStorage.removeItem("conversation-id");
      localStorage.removeItem("has-error");

      setMessages([{ ...initMessage, content: t('initMessage', lang) }]);
      setErrorBackend(false);
      setDisabledInput(false);
      setConversationId(null);

      navigate('/tcm-page?API_KEY=' + headers['TCM_API_KEY'] + '&mode=' + headers['mode']);
    }, [ lang, navigate, headers]);
    
    useEffect(() => {
      const loadMessage = (id) => {
        if (id.trim() !== '') {
          axios.get(baseUrl + '/chat/history/'+id, { headers })
          .then((res) => {
              // console.log(res)
              var data = res.data
              if (data.length !==0 ){
                axios.get(baseUrl + '/chat/last-chat-response', { headers, params: {conversation_id: id} })
                  .then((message_resp) => {
                    var last_message = message_resp.data

                    if (last_message) {
                      const now = new Date();
                      const messageDate = new Date(last_message.date_response_chatbot);

                      const diffInMs = now - messageDate;
                      const diffInHours = diffInMs / (1000 * 60 * 60);

                      if (diffInHours > 1) {
                        // 👉 More than 1 hour ago
                        console.log('Older than 1 hour', );
                        // do something
                        handleReset()
                      } 
                    }
                      
                    if (last_message!=null && last_message?.buttons?.length !== 0 ){
                      data[data.length - 1].buttons = last_message.buttons
                    }

                    setMessages([{...initMessage, content: t('initMessage', lang)}, ...data])
                  })
                  .catch(err => {
                    console.log(err, 'an error')
                  })
              }
              // setMessages(data)
              setMessages([{...initMessage, content: t('initMessage', lang)}, ...data])
              setIsLoadingHistory(false)
              if (chatBodyRef.current) {
                chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
              } 
              navigate("/tcm-page?conversation-id="+id + '&API_KEY='+headers['TCM_API_KEY'] + '&mode=' + headers['mode']);
            })
          .catch((err) => {
            // console.log(err);
            setConversationId(null)
          })
          .finally(() => {
            // setIsLoading(false); // End loading whether success or error
          });
        }
      }
      const conversation_id = searchParams.get('conversation-id', null);
      
      if (headers !== null && conversation_id !== null) {
        setIsLoadingHistory(true)
        // if(messages.length <= 1){
          // loadMessage(conversation_id); // Your custom function
        // }
        if(conversationId === null){
          loadMessage(conversation_id); // Your custom function
        }
        setConversationId(conversation_id)
      }

      if(headers && Object.keys(client).length === 0){
        axios.get(baseUrl + '/clients/get-client/', { headers})
          .then((res) => {
              var data = res.data 
              setCompany(data)
              axios.get(baseUrl + '/clients/config-chat/', { headers, params:{client_id: data.id}})
              .then((response) => {
                var config = response.data 
                if(config){
                  setClient(config)
                }
                setShowPage(true)
                if (chatBodyRef.current) {
                  chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
                }   
              })
          }).catch((err) => {
            setShowPage(false)
            // console.log(err.response.data, 'check')
            setErrorBackend(err.response.data)
          })
      }
    }, [headers, searchParams, navigate, baseUrl, conversationId, client, lang, handleReset]); // Triggers on new messages or loading indicator
  
    // console.log(showPage)
    useEffect(() => {
      if (chatBodyRef.current) {
        // chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
          chatBodyRef.current.scrollTo({
            top: chatBodyRef.current.scrollHeight,
            behavior: "smooth"
          });
      }
      if(messages.length > 0){
        var lastMessage = messages[messages.length - 1]
        if (
          lastMessage.buttons !== undefined 
          && lastMessage.buttons !== null
          && lastMessage.buttons.length > 0){
            if (lastMessage.buttons[0].type_button === "Button_choix"){
              setDisabledInput(true)
            }
            if (lastMessage.buttons[0].status === "End_Conversation"){
              setDisabledInput(true)
              var evalMessage = { content: t('ratingLabel'), role: "bot", status: 'in-progress', created_at: new Date(), lang: lang, type: "EVAL_MESSAGE"};
              setMessages(prev => [...prev, evalMessage]); // ✅ Don't use `messages` directly
            }
        }
      }
    }, [messages, isLoading, lang]); // Triggers on new messages or loading indicator


    useEffect(() => {
      const savedLang = localStorage.getItem("lang");
      if (savedLang) setLang(savedLang);
      
    }, []);


    const validateEmail = (value) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(value);
    };


    const setFavicon = (iconUrl) => {
      let link = document.querySelector("link[rel~='icon']");

      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }

      link.href = iconUrl;
    };

    useEffect(() => {
      // console.log(client, 'lll')
      if(client && client.logo_url){
        // document.title = 'Quebotia | '+company.name;
        setFavicon(client.logo_url);
      }
    }, [client]);

    useEffect(() => {
      if(company){
        document.title = 'Quebotia | '+company.name;
      }
    }, [company]);

    useEffect(() => {
      if (email !== "" || phone !== "") {
        if (validateEmail(email) && isValidPhoneNumber(phone)){
          setInput(phone + "," + email)
        } else if (email === ""){
          if(isValidPhoneNumber(phone)){
            setInput(phone+",")
          }else{
            setInput('')
          }
        }else if (phone.length <= 3){
          if (validateEmail(email)) {
            setInput(","+email)
          }else{
            setInput('')
          }
        }else{
          setInput('')
        }
      }else{
        setInput('')
      }
    }, [email, phone]); // Triggers on new messages or loading indicator

  const formatDateForBackend = (date) => {
    const pad = (num, size = 2) => String(num).padStart(size, '0');

    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1);
    const day = pad(date.getUTCDate());

    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const seconds = pad(date.getUTCSeconds());

    // JS only has milliseconds (3 digits), backend wants 6 → add 000
    const microseconds = pad(date.getUTCMilliseconds(), 3) + "000";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}+00`;
  };

  const handleEvaluation = () => {
    setDisabledInput(true)
    var evalMessage = { content: t('ratingLabel'), role: "bot", status: 'in-progress', created_at: new Date(), lang: lang, type: "EVAL_MESSAGE"};
    setMessages(prev => [...prev, evalMessage]); // ✅ Don't use `messages` directly
  }

  const sendMessage = () => {
    // if (input.trim() !== "" && isLoading === false ) {
    var time_now = new Date().getTime()
    if(time_now > endTime){
        // console.log(time_now, endTime, 'we should reset everything')
        handleReset()
    }
    if (canSend) {
      const userMessage = { content: input, role: "user", status: 'in-progress', created_at: new Date(), lang: lang, image_url: imageData !== null ? imageData.local_url : null};
      var lastMessage = {}
      if(messages.length !== 0){
        lastMessage = messages[messages.length - 1]
        if(lastMessage.type === "EVAL_MESSAGE"){
          userMessage.type = "EVAL_RESULT"
        }
      }

      setMessages(prev => [...prev, userMessage]); // ✅ Don't use `messages` directly
      setInput("");
      setIsLoading(true); // Start loading
      setDisabledInput(true)
      setErrorBackend(false)
      localStorage.setItem('has-error', "false")
      
      const date = new Date();
      // const formattedUTC = date.toISOString().split('.')[0] + 'Z';
      const formattedUTC = formatDateForBackend(date);

      
      var data = conversationId === null
      ? { message: input, date_msg_user : formattedUTC, lang: lang }
      : { message: input, conversation_id : conversationId, date_msg_user : formattedUTC, lang: lang  };


      if(messages.length !== 0){
        if(lastMessage.buttons && lastMessage?.buttons?.length !== 0){
            var lastItem = lastMessage.buttons[0]
            if (lastItem.type_button !== "Button_aide"){
              data = { 
                conversation_id: conversationId,
                date_msg_user : formattedUTC,
                lang: lang,
                button: {
                  status: lastItem.status,
                  value: input,
                  date_msg_user : formattedUTC
                }
              }
            }
        }else if (lastMessage.type === "EVAL_MESSAGE"){
            data = { 
              conversation_id: conversationId,
              date_response_chatbot : formattedUTC,
              lang: lang,
              rating: input,
            }
            return axios.post(baseUrl + '/chat/send-rating', data, { headers })
                    .then((res) => {
                      console.log(res, 'check')
                        localStorage.removeItem("last-buttons")
                        localStorage.removeItem('slots-rdv')
                        localStorage.removeItem('conversation-id')
                        localStorage.removeItem("has-error")
                        setDisabledInput(false)
                        // setMessages([{...initMessage, content: t('initMessage', lang)}])
                        setErrorBackend(false)
                        setConversationId(null)
                        navigate('/tcm-page?API_KEY='+headers['TCM_API_KEY']+ '&mode=' + headers['mode'])
                    })
                    .catch((err) => {
                        console.log(err, 'llll')
                        handleReset()
                    })
                    .finally(() => {
                      setIsLoading(false); // End loading whether success or error
                    });
        }

      }
      if (headers !== null){
        const formData = new FormData();
        formData.append("chat_request", JSON.stringify(data));
        // formData.append("chat_request", data);

        if(imageData){
          formData.append('image_file', imageData.file, imageData.file.name)
          setImageData(null)
        }
        // axios.post(baseUrl + '/chat/', data, { headers })
        axios.post(baseUrl + '/chat/', formData, { headers })
          .then((res) => {
              var response_data = res.data;
              

              response_data['role'] = 'bot'
              response_data['created_at'] = new Date()
              response_data['content'] = response_data.response
              setMessages(prev => [...prev, response_data]);
              setImageData(null)
              
              if (response_data.buttons){
                localStorage.setItem("last-buttons", JSON.stringify(response_data.buttons));
                var lastItem = response_data.buttons[0]
                if (lastItem.type_button !== "Button_aide"){
                  if (lastItem.status === "End_Conversation"){
                    // setConversationId(null)
                    setEmail("");
                    setPhone("");
                    setInput("");
                    // localStorage.removeItem('conversation-id')
                    handleEvaluation()
                    return 
                    // navigate('/tcm-page?API_KEY='+headers['TCM_API_KEY']+ '&mode=' + headers['mode'])
                  }else{
                    setConversationId(response_data.conversation_id)
                    setEndTime(new Date().getTime() + RESET_TIME)
                  }
                }else{
                  setConversationId(response_data.conversation_id)
                  setEndTime(new Date().getTime() + RESET_TIME)
                }
              }else{
                localStorage.setItem("last-buttons", JSON.stringify([]));
                setConversationId(response_data.conversation_id)
                setEndTime(new Date().getTime() + RESET_TIME)
              }

              if(conversationId == null){
                navigate('/tcm-page?API_KEY='+headers['TCM_API_KEY'] + '&conversation-id='+response_data.conversation_id + '&mode=' + headers['mode'])
              }
              // setConversationId(response_data.conversation_id);

              // setMessages(prev => [...prev, response_data]);
              setDisabledInput(false)
              if (chatBodyRef.current) {
                chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
              }
          })
          .catch((err) => {

                setMessages(prev => prev.slice(0, -1));
                setDisabledInput(true)
                setErrorBackend(true)
                setImageData(null)
                // localStorage.removeItem("last-buttons")
                // localStorage.removeItem('slots-rdv')
                localStorage.setItem('has-error', "true")
          })
          .finally(() => {
            setIsLoading(false); // End loading whether success or error
          });
      }
    }else{
      // console.log('still processing the previous message')
    }
  };

  function formatDate(date) {
    const d = new Date(date);
    
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    
    return `${d.getDate().toString().padStart(2, '0')}/${
      (d.getMonth() + 1).toString().padStart(2, '0')
    }/${d.getFullYear()} ${hours}:${minutes}:${seconds}`;
  }



  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setErrors((prev) => ({
      ...prev,
      email: validateEmail(value) ? '' : 'Invalid email address',
    }));
  };

  const handlePhoneChange = (value) => {
    // console.log(value)
    // const value = e.target.value;
    
    if (value !== undefined){
      setPhone(value);
      if(value.length >= 3){
        setErrors((prev) => ({
          ...prev,
          phone: isValidPhoneNumber(value) ? '' : 'Invalid phone number',
        }));
      }
    }
  };

  function trimCommas(str) {
    return str.replace(/^,|,$/g, '');
  }

  const openFilePicker = () => {
    fileInputRef.current.click();
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;

    for (let item of items) {
      if (item.type.startsWith("image")) {
        e.preventDefault(); // stop text/file name from appearing in textarea

        const file = item.getAsFile();
        handleFile(file); // your existing upload logic
        return;
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      console.log("Selected file:", file);
      handleFile(file)
    }
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    // setDragging(false);

    const file = e.dataTransfer.files[0];

    if (file && file.type.startsWith("image/")) {
      handleFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFile = (file) => {
    // console.log("Image dropped:", file);

    const imageUrl = URL.createObjectURL(file);
    setImageData(prev => ({
      file: file,
      local_url: imageUrl
    }))
  };
    const handleChangeLanguage = (langage) => {
      localStorage.setItem("lang", langage)
      setLang(langage)
      if(messages.length === 1){
        setMessages(([
          {...initMessage, content: t('initMessage', langage)},
        ]))
      }
    }
  const canSend = (input.trim() || imageData !== null ) && !isLoading
    console.log(messages, 'llll')
  return (
    showPage ? (
        <Container
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        maxWidth={false}
        disableGutters
        sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh", // 🔥 VERY IMPORTANT
            bgcolor: client.background_color || "#fff",
            fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
        }}
        >

            <Box
                sx={{
                    bgcolor: client.header_color || "#cac39c",
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexShrink: 0,
                    height: 60,
                }}
            >
            {/* Logo with link */}
            <Box
                component="a"
                href={
                company?.website
                    ? company.website.startsWith("http")
                    ? company.website
                    : `https://${company.website}`
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "flex", alignItems: "center" }}
            >
                <Box
                component="img"
                src={client.logo_url || logo}
                alt="Logo"
                sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    objectFit: "cover",
                    bgcolor: logoColor,
                }}
                onError={(e) => {
                    e.target.src = logo;
                }}
                />
            </Box>

            {/* Title */}
            <Typography
                variant="h6"
                sx={{
                color: client.chatbot_system_color || "#000",
                fontWeight: 600,
                }}
            >
                CHATBOT {company?.name?.toUpperCase() || company_name?.toUpperCase()}
            </Typography>

            {/* Language */}
            <LangGlobe
                lang={lang}
                setLang={setLang}
                handleChangeLanguage={handleChangeLanguage}
                client={client}
            />
            </Box>


            <Box
              sx={{
                  flex: 1,              // 🔥 takes all remaining space
                  overflowY: "auto",    // 🔥 scroll only here
                  px: 2,
                  py: 2,
              }}
              ref={chatBodyRef}
            >
                {messages.map((msg, i) => (
                <ChatMessage
                    key={i}
                    t={t}
                    largeText={true}
                    lang={lang}
                    msg={msg}
                    input={input}
                    setInput={setInput}
                    isLast={i === messages.length - 1}
                    client={client}
                    userAvatar={user}
                    botAvatar={admin}
                    formatDate={formatDate}
                    trimCommas={trimCommas}
                    handleReset={handleReset}
                    isLoading={isLoading}
                    isLoadingHistory={isLoadingHistory}
                    errorBackend={errorBackend}
                    onChange={(val) => {
                        setInput(val)
                        setDisabledInput(true)
                    }}
                />
                ))}

                {errorBackend ? (
                <ErrorComponent client={client} handleReset={handleReset} company={company} lang={lang} t={t}/>
                ): null}

            </Box>


          {messages.length > 0 &&
            messages[messages.length - 1]?.buttons?.length > 0 &&
            messages[messages.length - 1]?.buttons[0]?.type_button === "Button_aide" &&
            !isLoading && (
              
              <Box
                sx={{
                  borderTop: `1px solid ${client.line_color || "#adb5bd"}`,
                  p: 1
                }}
              >
                <Stack
                  direction="row"
                  // sx={{bgcolor: 'yellow'}}
                  spacing={1}
                  useFlexGap
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  // alignItems="center"
                  // justifyContent="center"
                  // flexWrap="wrap" // 🔥 allows wrapping nicely
                >
                  {messages[messages.length - 1].buttons.map((item, index) =>
                    item.type_button === "Button_aide" 
                      ? item.value.map((val, j) => (
                          <Button
                            key={j}
                            variant="contained"
                            size="small"
                            onClick={() => setInput(val)}
                            sx={{
                              bgcolor: client.help_button_color || "#98ceA1",
                              color: getContrastColor(
                                client.help_button_color || "#98ceA1"
                              ),
                              textTransform: "none",
                              fontSize: "0.9rem",
                              minWidth: 270,
                              borderRadius: 5,
                              "&:hover": {
                                opacity: 0.9
                              }
                            }}
                          >
                            {val}
                          </Button>
                        ))
                      : null
                  )}
                </Stack>
              </Box>
          )}

          {
            imageData && (
              <Box
                sx={{
                  borderTop: `1px solid ${client.line_color || "#adb5bd"}`,
                  display: "flex",
                  justifyContent: "center",
                  p: 1,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {/* DELETE BUTTON */}
                  <IconButton
                    size="small"
                    onClick={() => setImageData(null)}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      bgcolor: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      "&:hover": {
                        bgcolor: "rgba(0,0,0,0.8)",
                      },
                      width: 22,
                      height: 22,
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </IconButton>

                  {/* IMAGE */}
                  <Box
                    component="img"
                    src={imageData.local_url}
                    alt="preview"
                    sx={{
                      height: 85,
                      width: 85,
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            )
          }

          <Box
            sx={{
              flexShrink: 0, // 🔥 fixed at bottom
              borderTop: `1px solid ${client.line_color || "#ddd"}`,
              p: 1,
            }}
          >

              {messages.length > 0 
              && messages[messages.length - 1]?.buttons !== undefined 
              && messages[messages.length - 1]?.buttons !== null 
              && messages[messages.length - 1]?.buttons?.length !== 0 
              && !isLoading 
              && messages[messages.length - 1]?.buttons[0]?.status === 'Txt_contact' ?
                  (
                    <>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        width: "100%",
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                        {/* EMAIL */}
                        <Box sx={{ flex: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="email"
                            variant="outlined"
                            onChange={handleEmailChange}
                            // error={!!errors.email}
                            // helperText={errors.email}
                            sx={{
                              bgcolor: client.chatbot_place_holder || "#fff",
                              "& input": {
                                // color: client.chatbot_place_holder || "inherit",
                                fontSize: "14px",
                              },
                            }}
                          />
                        </Box>

                        {/* PHONE */}
                        <Box sx={{ flex: 1 }}>
                          <Box
                            sx={{
                              backgroundColor: client.chatbot_place_holder || "#fff",
                              borderRadius: 1,
                              // borderRadius: "12px",
                              p:0,
                              // px: 1,
                              // py: 0.5,
                              border: errors.phone ? "1px solid red" : "1px solid #ccc",
                            }}
                          >
                            <PlainPhoneInput
                              international
                              value={phone}
                              t={t}
                              onChange={handlePhoneChange}
                            />
                          </Box>
                        </Box>
                        <IconButton
                        onClick={sendMessage}
                        disabled={!canSend}
                        size='small'
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                        }}
                      >
                        <SendIcon />
                      </IconButton>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        width: "100%",
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                          {errors.phone && (
                            <Typography sx={{ color: "red", fontSize: 10, mt: 0.5 }}>
                              {errors.phone} {errors.phone && errors.email ? "," : null}
                            </Typography>
                          )}
                          
                          {errors.email && (
                            <Typography sx={{ color: "red", fontSize: 10, mt: 0.5 }}>
                              
                              {errors.email}
                            </Typography>
                          )}
                    </Box>
                    </>
              ) : 
              messages.length > 0 
              && messages[messages.length - 1]?.buttons !== undefined 
              && messages[messages.length - 1]?.buttons !== null 
              && messages[messages.length - 1]?.buttons?.length !== 0 
              && !isLoading 
              && messages[messages.length - 1]?.buttons[0]?.status === 'Txt_adress' ?
              (
                <Box sx={{ p: 1 }}>
                  <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    onPlaceSelected={(place) => {
                      if (place !== null){
                        console.log(place, 'oooo')
                        setInput(place.full_address)
                      }else{
                        setInput("")
                      }
                    }}
                    backgroundColor={client.chatbot_place_holder || "#fff"}
                    color={client.input_message_color || "#000"}
                    options={{
                      types: ["address"],
                    }}
                    placeholder={t("enterAddress", lang)}
                    className="chat-input" 
                  />

                  <IconButton
                      onClick={sendMessage}
                      disabled={!canSend}
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                            // color: "#fff",
                            // "&:hover": {
                            //   bgcolor: client.send_button_color || "#0bECAe",
                            // },
                        }}
                    >
                      <SendIcon />
                    </IconButton>
                  </Stack>
                </Box>

              ) : 
              (
                <Box sx={{ p: 1,}}>
                  <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
                      
                      {!disabledInput && (
                        <IconButton onClick={openFilePicker} disabled={disabledInput}>
                            <AddIcon />
                        </IconButton>
                      )}

                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      <TextField
                        fullWidth
                        multiline
                        minRows={1}
                        maxRows={2}
                        disabled={disabledInput}
                        placeholder={t("placeholder", lang)}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onPaste={handlePaste}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage();
                            }
                        }}
                        size="small"
                      />

                      <IconButton
                        onClick={sendMessage}
                        disabled={!canSend}
                        sx={{
                            color: client.send_button_color || "#0bECAe",
                            // color: "#fff",
                            // "&:hover": {
                            //   bgcolor: client.send_button_color || "#0bECAe",
                            // },
                        }}
                      >
                        <SendIcon />
                      </IconButton>
                  </Stack>
                </Box>
              )}

            </Box>
            <ChatFooter t={t} client={client} baseUrl={baseUrl} lang={lang}/>
      </Container>
    ) :   
      <Box
        sx={{
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {errorBackend ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            {/* Spinner */}
            {/* <CircularProgress /> */}

            {/* Text */}
            <Typography variant="body1" color="text.secondary">
              {errorBackend.detail}
            </Typography>
          </Box>
        ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          {/* Spinner */}
          <CircularProgress />

          {/* Text */}
          <Typography variant="body2" color="text.secondary">
            Loading, please wait...
          </Typography>
        </Box>
        )}

      </Box>
  );
};

export default FullPageChat;


